export default {
  invoices: (state) => state.invoices,
  invoice: (state) => state.invoice,
  invoiceHelpers: (state) => state.invoiceHelpers,
  getTotalFee: (state) => {
    return state.invoice.shipments.data.reduce(
      (pv, cv) => pv + cv.total_fee,
      0
    );
  },
  getTotalCOD: (state) => {
    return state.invoice.shipments.data.reduce(
      (pv, cv) => pv + cv.amount_for_cross,
      0
    );
  },
  getTotalFeeDifference: (state) => {
    return state.invoice.shipments.data.reduce(
      (pv, cv) => pv + (cv.compare_fee.data.total_fee - cv.compare_fee.data.last_total_fee),
      0
    );
  },
  getArearAmount: (state) => {
    const arearAmount = state.invoice.money_return;
    const isDebt =
      state.invoice.returneds.data.length > 0 ||
      state.invoice.returns.data.length > 0;
    return isDebt ? arearAmount * -1 : arearAmount;
  },
};



// WEBPACK FOOTER //
// ./src/components/invoice/store/getters.js